import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=122bda0e&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=122bda0e&prod&scoped=true&lang=css&"
import style1 from "./setting.vue?vue&type=style&index=1&id=122bda0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122bda0e",
  null
  
)

export default component.exports